// Footer newsletter promo bootstrap.
// Submit / validation / toast are handled by subscribe-form.js (form_id: footer-promo).
// This file only keeps deferred-component readiness + optional phone dial init.

function initFooterNewsletterPromo() {
  const formRoot = document.querySelector('[data-form-id="footer-promo"][data-subscribe-form]');

  if (formRoot && formRoot.dataset.showPhone === "true" && typeof window.initSubscribeFormPhoneCode === "function") {
    window.initSubscribeFormPhoneCode(formRoot).catch(function (error) {
      console.warn("[footer-newsletter-promo] phone code init failed", error);
    });
  }

  // Ensure all-collection deferred click interceptor releases the submit button.
  const root = document.querySelector(".footer-newsletter-promo[data-all-deferred]");
  if (root && root.dataset.allInitialized !== "true") {
    root.dataset.allInitialized = "true";
    root.dispatchEvent(new CustomEvent("ecoflow:component-ready"));
  }
}

if (document.querySelector(".footer-newsletter-promo[data-all-deferred]") || document.readyState !== "loading") {
  initFooterNewsletterPromo();
} else {
  document.addEventListener("DOMContentLoaded", initFooterNewsletterPromo, { once: true });
}
